import { Injectable, signal } from '@angular/core';

/** An authorized page may replace its route's generic name while it is active. */
@Injectable({ providedIn: 'root' })
export class PageIdentityService {
  private owner?: object;
  readonly identity = signal<{ path: string; label: string } | null>(null);
  set(owner: object, path: string, label: string): void {
    this.owner = owner;
    this.identity.set({ path: path.split('?')[0], label });
  }
  clear(owner: object): void {
    if (this.owner === owner) { this.owner = undefined; this.identity.set(null); }
  }
}
